export default __webpack_public_path__ + "static/media/CreateBackupJobDetails-MySQL.8c502e4f.png";